import Vue from "vue";
import PhotoGallery from "./PhotoGallery.vue";

export function load() {
  const selector = "photoGallery-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(PhotoGallery, {
        props: {
          ...window[selector]
        }
      })
  }).$mount(selector);
}
